module.exports = __webpack_public_path__ + "static/curtain-2c8adfd18ca79808425cd1294495bf51.jpg";